import React from 'react';
import * as _ from 'lodash';
import { translate } from 'react-i18next';

import WrapperSecondary from '../common/WrapperSecondary';

const Screen = ({ t }) => (
  <WrapperSecondary>
    <h2 className="u-text-center u-margin-bottom">{t('notFound.title')}</h2>
    <img
      alt="404"
      src={_.sample([
        'https://i.imgur.com/JyIR8Sf.jpg',
        'https://i.imgur.com/ZklENze.jpg',
        'https://i.imgur.com/CvylrUU.jpg',
        'https://i.imgur.com/MyMMGjc.jpg',
        'https://i.imgur.com/VO96vh3.jpg',
        'https://i.imgur.com/b0TrspL.jpg',
        'https://i.imgur.com/rjE5UxC.jpg',
        'https://i.imgur.com/k62BYve.jpg',
        'https://i.imgur.com/JPVZtOW.jpg',
        'https://i.imgur.com/hB72ph4.jpg',
        'https://i.imgur.com/RIbps9y.jpg',
        'https://i.imgur.com/xzT6Z0k.jpg',
        'https://i.imgur.com/6y6mXMx.jpg',
      ])}
    />
  </WrapperSecondary>
);

export default translate()(Screen);



// WEBPACK FOOTER //
// ./src/not-found/Screen.js